import{HelgaReferenceImage}from"@joinbox/helga-animations";HelgaReferenceImage.defineCustomComponent();